/** Maps ngx-translate language codes to Angular locale ids for DatePipe / formatDate. */
export function resolveAngularLocale(lang: string | null | undefined): string {
  const normalized = (lang ?? "en").toLowerCase();

  if (normalized.startsWith("es")) {
    return "es";
  }

  return "en-US";
}
